module.exports = __webpack_public_path__ + "img/drink_coupon_chiba_used_old.f8bfa291.png";